import { cn } from "@/lib/utils";
import { ComponentPropsWithRef } from "react";
import { PrevNextButtonPropsModel } from "./PullQuoteCarousel.model";

export const PrevButton = ({
  className,
  canScrollPrev,
  onClick,
  children,
  ...props
}: PrevNextButtonPropsModel) => {
  return (
    <button
      className={cn(
        "relative flex h-4 w-[45px] items-center justify-center border-r border-l border-black px-2 disabled:opacity-30",
        className,
      )}
      type="button"
      disabled={!canScrollPrev}
      onClick={onClick}
      aria-label="previousquote"
      {...props}
    >
      {children}
      <p className="text-sm">&lt;</p>
      <span className="absolute top-0 right-0 h-1 w-1 border-t border-black"></span>
      <span className="absolute top-0 left-0 h-1 w-1 border-t border-black"></span>
      <span className="absolute right-0 bottom-0 h-1 w-1 border-b border-black"></span>
      <span className="absolute bottom-0 left-0 h-1 w-1 border-b border-black"></span>
    </button>
  );
};

export const NextButton = ({
  className,
  canScrollNext,
  onClick,
  children,
  ...props
}: PrevNextButtonPropsModel) => {
  return (
    <button
      className={cn(
        "relative flex h-4 w-[45px] items-center justify-center border-r border-l border-black px-2 disabled:opacity-30",
        className,
      )}
      type="button"
      disabled={!canScrollNext}
      onClick={onClick}
      aria-label="nextquote"
      {...props}
    >
      {children}
      <p className="text-sm">&gt;</p>
      <span className="absolute top-0 left-0 h-1 w-1 border-t border-black"></span>
      <span className="absolute bottom-0 left-0 h-1 w-1 border-b border-black"></span>
      <span className="absolute top-0 right-0 h-1 w-1 border-t border-black"></span>
      <span className="absolute right-0 bottom-0 h-1 w-1 border-b border-black"></span>
    </button>
  );
};

export const DotButton: React.FC<ComponentPropsWithRef<"button">> = props => {
  const { children, className, ...restProps } = props;

  return (
    <button
      type="button"
      className={cn(
        "m-0 h-[1rem] w-[1rem] cursor-pointer touch-manipulation rounded-full border border-black bg-transparent p-0",
        className,
      )}
      {...restProps}
    >
      {children}
    </button>
  );
};
